export const EDeductionPlanType = {
  EMPLOYEE: "employee",
  COMPANY: "company",
  CONTRACTOR: "contractor",
} as const;

export type EDeductionPlanType =
  (typeof EDeductionPlanType)[keyof typeof EDeductionPlanType];
